/** @jsxImportSource ../../i18n */
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { debateLivePath, startDebate } from '../../services/debates';
import { Banner, Button, Dialog, Field, Textarea } from '../ui';

// "Débat d'experts" button: asks the panel to debate one instrument now
// (optional question), then follows the debate live.
export const DebateLauncher = ({ symbol, description, size = 'md', variant = 'secondary' }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const field = useRef(null);

  const launch = async () => {
    setBusy(true);
    setError('');
    try {
      const runId = await startDebate({ symbol, description, question });
      setOpen(false);
      navigate(debateLivePath(runId));
    } catch (err) {
      setError(err?.response?.data?.error || 'Impossible de lancer le débat.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button size={size} variant={variant} leadingIcon={Users} onClick={() => setOpen(true)}>Débat d’experts</Button>
      <Dialog
        open={open}
        onClose={() => !busy && setOpen(false)}
        title={`Débat d’experts sur ${symbol}`}
        description="Le panel recherche l’actualité de la valeur, chaque expert l’analyse, puis la table ronde tranche et le rapporteur conclut. Le débat se suit en direct et utilise les clés de vos experts."
        initialFocusRef={field}
        footer={(
          <>
            <Button variant="secondary" onClick={() => setOpen(false)} disabled={busy}>Annuler</Button>
            <Button onClick={launch} loading={busy}>Lancer le débat</Button>
          </>
        )}
      >
        <Field label="Votre question" optional="facultatif" htmlFor="debate-question">
          <Textarea ref={field} id="debate-question" maxLength={500} value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="ex. Faut-il renforcer avant les résultats ?" />
        </Field>
        {error && <Banner tone="loss" role="alert" className="mt-4">{error}</Banner>}
      </Dialog>
    </>
  );
};
